import * as Yup from "yup";

export default Yup.object().shape({
  company: Yup.string().required("Company is required"),
  department: Yup.string().required("Department is required"),
  jobTitle: Yup.string().required("Job title is required"),
  employmentType: Yup.string().required("Employment type is required"),
  dateOfJoining: Yup.date()
    .typeError("Invalid date format")
    .required("Date is required")
    .when("employmentType", {
      is: "Substitute",
      then: (schema) =>
        schema.test("dateOfJoining-not-after-endDate", "Date of joining cannot be after end date", function (value) {
          const { substituteEndDate } = this.parent;
          if (!value || !substituteEndDate) return true;
          const join = new Date(value);
          const end = new Date(substituteEndDate);
          join.setHours(0, 0, 0, 0);
          end.setHours(0, 0, 0, 0);
          return join.getTime() <= end.getTime();
        }),
    }),
  employeeHrStartDate: Yup.date()
    .nullable()
    .typeError("Invalid date format")
    .test(
      "hrStartDate-not-after-dateOfJoining",
      "Employee Start Date (HR) cannot be after Date of joining",
      function (value) {
        const { dateOfJoining } = this.parent;
        if (!value || !dateOfJoining) return true;
        const hrStart = new Date(value);
        const join = new Date(dateOfJoining);
        hrStart.setHours(0, 0, 0, 0);
        join.setHours(0, 0, 0, 0);
        return hrStart.getTime() <= join.getTime();
      }
    ),
  substituteEndDate: Yup.date()
    .nullable()
    .when("employmentType", {
      is: "Substitute",
      then: (schema) =>
        schema.test("endDate-not-before-joinDate", "End date cannot be before date of joining", function (value) {
          const { dateOfJoining } = this.parent;
          if (!value || !dateOfJoining) return true;
          const end = new Date(value);
          const join = new Date(dateOfJoining);
          end.setHours(0, 0, 0, 0);
          join.setHours(0, 0, 0, 0);
          return end.getTime() >= join.getTime();
        }),
    }),
});
